import { render, staticRenderFns } from "./Faceprint.vue?vue&type=template&id=75a55b04&scoped=true"
import script from "./Faceprint.vue?vue&type=script&lang=js"
export * from "./Faceprint.vue?vue&type=script&lang=js"
import style0 from "./Faceprint.vue?vue&type=style&index=0&id=75a55b04&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a55b04",
  null
  
)

export default component.exports